import { createSlice } from '@reduxjs/toolkit';

const accessTokenJSON = localStorage.getItem('auth');

const { actions, reducer } = createSlice({
  name: 'auth',
  initialState: {
    accessToken: accessTokenJSON ? JSON.parse(accessTokenJSON).accessToken : '',
    refreshToken: accessTokenJSON ? JSON.parse(accessTokenJSON).refreshToken : '',
    email: accessTokenJSON ? JSON.parse(accessTokenJSON).user.email : '',
    name: accessTokenJSON ? JSON.parse(accessTokenJSON).user.name : '',
    surname: accessTokenJSON ? JSON.parse(accessTokenJSON).user.surname : '',
    userId: accessTokenJSON ? JSON.parse(accessTokenJSON).user.userId : '',
    profileImage: accessTokenJSON ? JSON.parse(accessTokenJSON).user.profileImage : '',
  },
  reducers: {
    setUser: (state, action) => {
      state.accessToken = action.payload.accessToken ?? '';
      state.email = action.payload.user?.email ?? '';
      state.name = action.payload.user?.name ?? '';
      state.surname = action.payload.user?.surname ?? '';
      state.userId = action.payload.user?._id ?? '';
      state.refreshToken = action.payload.refreshToken ?? '';
      state.profileImage = action.payload.profileImage ?? '';
      localStorage.setItem('auth', JSON.stringify(action.payload));
    },
    setName: (state, action) => {
      state.name = action.payload;
    },
    setSurname: (state, action) => {
      state.surname = action.payload;
    },
    removeUser: (state) => {
      state.accessToken = '';
      state.refreshToken = '';
      state.email = '';
      state.name = '';
      state.surname = '';
      state.userId = '';
      state.profileImage = '';
      localStorage.removeItem('auth');
    },
  },
});

export const { setUser, removeUser, setName, setSurname } = actions;
export const authSlice = reducer;
